import React from "react";
import { useFormContext } from "react-hook-form";
import FlightIcon from "../../../../assets/icons/auth-form/flight.png";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";
import { EMPTY_STRING } from "../../../../constants";

const options = [
  { title: "2-4 Hours Flight", icon: FlightIcon, id: 1 },
  { title: "4-8 Hours Flight", icon: FlightIcon, id: 2 },
  { title: "8-16 Hours Flight", icon: FlightIcon, id: 3 },
  { title: "16-24 Hours+ Flight", icon: FlightIcon, id: 4 },
];
const HolidayDestinationPreference = () => {
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <div>
      <div className="question-heading">
        How long do you want to travel to holiday destinations like busy cities,
        far away get aways, winter sun,{" "}
        <span className="fw-700">
          we include flight times to major destinations.
        </span>
      </div>
        {errors.travelDistanceHoliday && (
          <div className="error">
            {errors.travelDistanceHoliday.message}
          </div>
        )}
      <div className="form-fields">
        {options.map((option, index) => (
          <SurveyFormField
            name="travelDistanceHoliday"
            key={index}
            variant="radio"
            label={option.title}
            value={option.id}
            endAdornment={
              option.icon && (
                <div className="position-absolute marks-adornment">
                  <img src={option.icon} alt={EMPTY_STRING} />
                </div>
              )
            }
          />
        ))}
      </div>
    </div>
  );
};

export default HolidayDestinationPreference;
